import { ChevronRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const LABELS: Record<string, string> = {
  search: "Kërko",
  commerce: "Dyqani",
  businesses: "Bizneset",
  doctor: "Mjeku",
  about: "Rreth nesh",
  dashboard: "Dashboard",
  patient: "Pacienti",
  professional: "Mjeku",
  laboratory: "Laboratori",
  family: "Kujdesi Familjar",
  admin: "Admin",
  corporate: "Korporata",
  finance: "Financat",
  wallet: "Wallet",
  favorites: "Preferencat",
  messages: "Mesazhet",
  cart: "Shporta",
  orders: "Porositë",
};

interface Props {
  rootHref: string;
  rootLabel?: string;
}

function prettify(value: string): string {
  return decodeURIComponent(value).replace(/[-_]+/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}

function cleanTitle(title: string): string {
  return title.split("|")[0]?.trim() || "";
}

export const Breadcrumbs = ({ rootHref, rootLabel = "Ballina" }: Props): JSX.Element | null => {
  const location = useLocation();
  const state = (location.state ?? {}) as { from?: string; breadcrumbLabel?: string };
  const segments = location.pathname.split("/").filter(Boolean);
  const isApp = segments[0] === "app";
  const parts = isApp ? segments.slice(1) : segments;
  const titleLabel = typeof document !== "undefined" ? cleanTitle(document.title) : "";

  if (parts.length === 0) return null;

  const items = [{ href: rootHref, label: rootLabel }];
  let current = isApp ? "/app" : "";

  parts.forEach((part, index) => {
    current += `/${part}`;
    const isLast = index === parts.length - 1;
    const prev = parts[index - 1];
    const dynamic =
      (prev === "businesses" || prev === "doctor" || prev === "product") && isLast;
    const label = dynamic
      ? state.breadcrumbLabel || titleLabel || prettify(part)
      : LABELS[part] || prettify(part);
    items.push({ href: current, label });
  });

  if (!isApp && parts[0] === "doctor" && items[1]) {
    items[1] = { href: state.from || "/search", label: "Kërko" };
  }
  if (!isApp && parts[0] === "commerce" && parts[1] === "product" && items[1]) {
    items[1] = { href: state.from || "/commerce", label: "Dyqani" };
  }

  return (
    <nav aria-label="Gjurmët e navigimit" className="flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
      {items.map((item, index) => (
        <span key={`${item.href}-${item.label}`} className="inline-flex items-center gap-2">
          {index > 0 ? <ChevronRight className="h-4 w-4" aria-hidden="true" /> : null}
          {index === items.length - 1 ? (
            <span className="font-medium text-foreground">{item.label}</span>
          ) : (
            <Link to={item.href} className="transition hover:text-primary">
              {item.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
};
